module.exports = __webpack_public_path__ + "static/img/image12.1b9fe0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/image12.png
// module id = 76UK
// module chunks = 14